import React from 'react';
import { Link } from 'gatsby';
import SwiperCore, { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import { withSlider } from '../../context/SliderContext';

import Image from '../image';
import Close from '../icons/close';

import RecipeIngredients from './ingredients/';
import RecipeSteps from './steps/';
import RecipeVideo from './video/';

import './recipe.css';

type RecipeProps = {
  recipe: Recipe;
  setSlide: (slide: number) => {};
};

type RecipeState = {
  step: number
}


class RecipePage extends React.Component<RecipeProps, RecipeState> {
  trackingLoaded = false;
  trackingTry = 20;


  constructor(props: RecipeProps) {
    super(props);

    this.state = {
      step: 0
    };

    SwiperCore.use([Navigation]);
  }

  sendTracking() {
    if (this.trackingTry <= 0) {
      return;
    }

    const isTrackingActive = typeof window !== 'undefined' && typeof window.tC !== 'undefined';

    if (!this.trackingLoaded && !isTrackingActive) {
      this.trackingTry--;

      if (this.trackingTry <= 0) {
        return;
      }

      return setTimeout(this.sendTracking, 200);
    }

    this.trackingLoaded = true;

    setTimeout(() => {
      if ( typeof window !== 'undefined' && typeof window.tC !== 'undefined' ) {
          window.tc_vars.pagename = document.title;
          window.tC.container.reload();
          window.tC.event.pageview(window,{});
      }
    }, 100);
  }

  componentDidMount() {
    const { recipe, setSlide } = this.props;
    setSlide(parseInt(recipe.pid, 10) - 1);

    this.sendTracking();
  }


  render() {
    const { step } = this.state;
    const { recipe } = this.props;

    const isVideo = recipe.video != null;

    return (
      <div className={`recipe-wrapper ${recipe.rid}`}>
        <RecipeSteps current={step} length={recipe.steps.length + 1} />
        <Link className="recipe-back-link" to="/" title="Retour a l'accueil">
          <Close fill={recipe.style.fill} stroke={recipe.style.stroke} />
        </Link>
        <Swiper
          id="recipe"
          navigation
          slidesPerView={1}
          onSlideChange={event => this.setState({ step: event.activeIndex })}
        >

        { isVideo && 
            <SwiperSlide className="swiper-slide-video">
              <RecipeVideo
                  url={recipe.video.url}
                  poster={recipe.video.poster}
                />
            </SwiperSlide>
          }

          <SwiperSlide className="swiper-slide-ingredients">
            <RecipeIngredients
              pid={recipe.pid}
              informations={recipe.information}
              ingredients={recipe.ingredients}
            />
          </SwiperSlide>
          {recipe.steps.map((step, index) => (
            <SwiperSlide key={index} className="swiper-slide-step">
              { step.image && 
                <div className="recipe-image recipe-step-3 gatsby-image-wrapper" style={{position: "relative", overflow: "hidden"}}><div aria-hidden="true" style={{width: "100%", paddingBottom: "80%"}}></div><img src={step.image} alt={`Étape ${index + 1}`} loading="lazy" style={{position: "absolute", top: 0, left: 0, width: "100%", height: "100%", objectFit: "cover", objectPosition: "center center", opacity: 1, transition: "none 0s ease 0s"}} /></div>
              }
              { !step.image && <Image
                alt={`Étape ${index + 1}`}
                className={`recipe-image recipe-step-${index}`}
                path={`${recipe.pid}-step-${index + 1}.jpg`}
              /> }
              <div className="recipe-text">
                <p dangerouslySetInnerHTML={{__html: step.description}}/>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    );
  }
}


export default withSlider(RecipePage);
